// extracted by mini-css-extract-plugin
export default {"wrapper":"Mo","form":"No","checkbox":"Oo","successWrapper":"Po","success":"Qo","successText":"Ro","circle":"So","footnote":"To","required":"Uo"};